import { j as g, k as x, l as m, h as b, r as h, m as O } from "./export-cdcbfb2b.js";
import { f as $, a as S, r as j } from "./es.string.replace-f4cc3aea.js";
import { t as p } from "./to-string-92a62764.js";
var E = g, I = $, w = x, L = m, R = b, t = p, U = h, q = O, y = S, s = j;
I("match", function(i, u, d) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function(r) {
      var e = U(this), a = L(r) ? void 0 : q(r, i);
      return a ? E(a, r, e) : new RegExp(r)[i](t(e));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function(l) {
      var r = w(this), e = t(l), a = d(u, r, e);
      if (a.done)
        return a.value;
      if (!r.global)
        return s(r, e);
      var f = r.unicode;
      r.lastIndex = 0;
      for (var o = [], n = 0, v; (v = s(r, e)) !== null; ) {
        var c = t(v[0]);
        o[n] = c, c === "" && (r.lastIndex = y(e, R(r.lastIndex), f)), n++;
      }
      return n === 0 ? null : o;
    }
  ];
});
